import MkuInput from './src/input';

MkuInput.install = function (Vue) {
  Vue.component(MkuInput.name, MkuInput);
};

export default MkuInput;
